import React from 'react';
import { FadeIn, Button, CountdownTimer } from './Shared';
import { Lock, Zap, ShieldCheck, CreditCard } from 'lucide-react';
export const FinalCTA = () => {
  return <section className="py-10 md:py-16 px-4 bg-navy-800/50 relative overflow-hidden" data-id="element-81">
      <div className="absolute inset-0 bg-gradient-to-t from-navy-900 to-transparent" data-id="element-82"></div>

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-83">
        <FadeIn data-id="element-84">
          <h2 className="text-sm font-bold tracking-widest text-red-400 uppercase mb-6" data-id="element-85">
            ⏰ ÚLTIMA OPORTUNIDAD
          </h2>
          <div className="mb-12" data-id="element-86">
            <CountdownTimer data-id="element-87" />
          </div>

          <div className="space-y-6 max-w-2xl mx-auto mb-12" data-id="element-88">
            <div className="bg-navy-900 p-6 rounded-2xl border border-navy-700 hover:border-gold-500/30 transition-all" data-id="element-89">
              <div className="flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-90">
                <div className="text-left" data-id="element-91">
                  <h4 className="text-xl font-serif font-bold text-white" data-id="element-92">
                    🌙 MEGAPACK NOCHES DE PAZ
                  </h4>
                  <div className="mt-1" data-id="element-93">
                    <span className="text-gray-500 line-through text-sm mr-2" data-id="element-94">
                      $61.000
                    </span>
                    <span className="text-2xl font-bold text-gold-400" data-id="element-95">
                      $19.990 <span className="text-sm text-gray-400" data-id="element-96">ARS</span>
                    </span>
                  </div>
                </div>
                <Button href="https://mundopractico.online/cart/48588077203673:1" className="w-full md:w-auto" data-id="element-97">
                  → QUIERO MI MEGAPACK AHORA
                </Button>
              </div>
            </div>

            <div className="bg-gradient-to-r from-navy-800 to-navy-900 p-6 rounded-2xl border border-gold-500/50 shadow-lg shadow-gold-500/5" data-id="element-98">
              <div className="flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-99">
                <div className="text-left" data-id="element-100">
                  <h4 className="text-xl font-serif font-bold text-white" data-id="element-101">
                    🏆 MEGAPACK + RECONEXIÓN
                  </h4>
                  <div className="mt-1" data-id="element-102">
                    <span className="text-gray-500 line-through text-sm mr-2" data-id="element-103">
                      $79.000
                    </span>
                    <span className="text-2xl font-bold text-gold-400" data-id="element-104">
                      $27.990 <span className="text-sm text-gray-400" data-id="element-105">ARS</span>
                    </span>
                  </div>
                </div>
                <Button href="https://mundopractico.online/cart/48588081660121:1" className="w-full md:w-auto" data-id="element-106">
                  → QUIERO EL MEGAPACK + RECONEXIÓN
                </Button>
              </div>
            </div>
          </div>

          <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-sm font-medium text-gray-400" data-id="element-107">
            <div className="flex items-center" data-id="element-108">
              <Lock className="w-4 h-4 mr-2" data-id="element-109" /> Pago 100% seguro
            </div>
            <div className="flex items-center" data-id="element-110">
              <Zap className="w-4 h-4 mr-2" data-id="element-111" /> Acceso en 5 minutos
            </div>
            <div className="flex items-center" data-id="element-112">
              <ShieldCheck className="w-4 h-4 mr-2" data-id="element-113" /> Garantía 7 días
            </div>
            <div className="flex items-center" data-id="element-114">
              <CreditCard className="w-4 h-4 mr-2" data-id="element-115" /> Mercado Pago
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};